@if (!isMobile) {
    <div class="full-content">
      <google-map class="map-frame"
          (mapClick)="mapClick()"
          [options]="mapOptions"
          (mapInitialized)="loadTechnicianTicketMap($event)"
          (fullscreenchange)="fullTechnicianTicketScreenchange()">
          @for (bin of markersTechnicianTicketsArray; track bin; let i = $index) {
          @if(isNumber(bin.lat) && isNumber(bin.lng)){
              <map-marker #marker="mapMarker"
              (mapClick)="openMarkerInfoWindow(marker, i);clickedMarker(bin)"
              [position]="{lat: bin.lat, lng: bin.lng}"
              [visible]="bin.visible"
              [options]="{ icon: { url: bin.icon }, opacity: bin.opacity ?? 1 }">
          </map-marker>
          <map-info-window #infoWindow>
              <div id="iw-event-container">
              <div id="singleBinInfo"></div>
              </div>
          </map-info-window>
          }
          }
      </google-map>
  </div>
}
  
  @if (isMobile) {
    <div class="full-content">
        <google-map class="map-frame"
          (mapClick)="mapClick()"
          [options]="mobileMapOptions"
          (mapInitialized)="loadTechnicianTicketMap($event)"
          (fullscreenchange)="fullTechnicianTicketScreenchange()">
          @for (bin of markersTechnicianTicketsArray; track bin; let i = $index) {
            @if(isNumber(bin.lat) && isNumber(bin.lng)){
              <map-marker #marker="mapMarker"
              [position]="{lat: bin.lat, lng: bin.lng}"
              [visible]="bin.visible"
              [options]="{ icon: { url: bin.icon }, opacity: bin.opacity ?? 1 }"
              (mapClick)="openMarkerInfoWindow(marker, i);clickedMarker(bin)">
            </map-marker>
            <map-info-window #infoWindow>
              <div id="iw-event-container">
                <div id="singleBinInfo"></div>
              </div>
            </map-info-window>
            }
          }
        </google-map>
    </div>
  }
  